import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e463d4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_checkbox = _resolveComponent("app-checkbox")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dataRequest)
      ? (_openBlock(), _createBlock(_component_app_loader, { key: 0 }))
      : (_openBlock(), _createBlock(_component_Form, {
          key: 1,
          as: "el-form",
          onSubmit: _ctx.nextStep
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_select, {
              modelValue: _ctx.professionDetailValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.professionDetailValue) = $event)),
              name: "professionDetail",
              label: _ctx.$localize(_ctx.label),
              placeholder: _ctx.$localize(_ctx.placeholder),
              options: _ctx.professionDetailList,
              filterable: ""
            }, null, 8, ["modelValue", "label", "placeholder", "options"]),
            (!_ctx.hideStudent)
              ? (_openBlock(), _createBlock(_component_app_checkbox, {
                  key: 0,
                  class: "app-form-control",
                  name: "isStudent",
                  modelValue: _ctx.isStudent,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isStudent) = $event)),
                  checked: _ctx.isStudent,
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isResident = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('registration.step-3.student.label')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "checked"]))
              : _createCommentVNode("", true),
            (!_ctx.hideResident)
              ? (_openBlock(), _createBlock(_component_app_checkbox, {
                  key: 1,
                  class: "app-form-control",
                  name: "isResident",
                  modelValue: _ctx.isResident,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isResident) = $event)),
                  checked: _ctx.isResident,
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isStudent = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('registration.step-3.resident.label')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "checked"]))
              : _createCommentVNode("", true),
            (_ctx.isStudent || _ctx.isResident)
              ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 2,
                  modelValue: _ctx.graduationDate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.graduationDate) = $event)),
                  type: "date",
                  name: "graduationDate",
                  label: _ctx.$localize('registration.step-3.graduationDate.label'),
                  placeholder: _ctx.$localize('registration.step-3.graduationDate.placeholder'),
                  size: _ctx.size,
                  "disabled-date": _ctx.disabledDate,
                  editable: false
                }, null, 8, ["modelValue", "label", "placeholder", "size", "disabled-date"]))
              : _createCommentVNode("", true),
            _createVNode(_component_app_button, {
              type: "primary",
              "native-type": "submit",
              class: "w-100 el-button-lg",
              disabled: _ctx.professionDetailValue === undefined || ((_ctx.isStudent || _ctx.isResident) && !_ctx.graduationDate),
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.next.button')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
  ]))
}